import React, { useEffect, useRef, useState } from "react";

import { Checkbox, FormHelperText, Grid } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import Notification from "../../../../components/Common/Notification";
import LoadingDialog from "../../../../components/Common/LoadingDialog";
import CustomButton from "../../../../components/Form/CustomButton";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import "../../setting.css"
import TablePageControl from "../../../../components/Common/TablePageControl";
import Table from "../../../../components/Common/Table";
import SearchBar from "../../../../components/Common/Searchbar";
import AppDialog from "../../../../components/Common/AppDialog";
import CustomTextField from "../../../../components/Form/CustomTextField";
import CustomIconButton from "../../../../components/Form/CustomIconButton";
import CustomSelect2 from "../../../../components/Form/CustomSelect2";
import Label from "../../../../components/Common/Label";
import { bulkDeleteService, bulkDeleteServiceType, deleteService, exportService, getGeneral, getServiceListing, resetServiceAttachmentState, resetServiceState } from "../../../../store/actions";
import Helpers from "../../../../helpers/helpers";
import DeleteModal from "../../../../components/Common/DeleteModal";


const ViewService = ({ title, serviceListing, exportServiceDocument, serviceList, userPermission, deleteServiceItem, bulkDelete }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { ID } = useParams();

    useEffect(() => {
        dispatch(resetServiceState());
    }, [])

    const [loading, setIsLoading] = useState(false);
    const [serviceTypeName, setServiceTypeName] = useState('');
    const [filterStatus, setFilterStatus] = useState('all');
    const [values, setFormValues] = useState({ category: '' });
    const [selectedRow, setSelectedRow] = useState([]);
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [keyword, setSearch] = useState("");
    const [sort, setSorted] = useState("asc");
    const [sort_by, setSortBy] = useState("");
    const [error, setError] = useState();
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [creatable, setCreatable] = useState(false);
    const [editable, setEditable] = useState(false);
    const [deletable, setDeletable] = useState(false);
    const [exportable, setExportable] = useState(false);
    const searchRef = useRef(keyword);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-setting") && setCreatable(true);
            userPermission?.includes("edit-setting") && setEditable(true);
            userPermission?.includes("delete-setting") && setDeletable(true);
            userPermission?.includes("export-setting") && setExportable(true);
            !userPermission?.includes("view-setting") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        searchRef.current = keyword;
    }, [keyword])

    useEffect(() => {
        if (deleteServiceItem?.code === "success") {
            setDeleteModalOpen(false);
            setNotification({
                open: true,
                msg: "Delete service successfully",
                type: "success",
            });
            dispatch(resetServiceState());
            initData();
        }
        setIsLoading(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deleteServiceItem]);

    useEffect(() => {
        if (checkedAll && serviceListing?.data) {
            const productListingIDs = serviceListing.data.map((item) => item.id);
            setSelectedRow(productListingIDs);
        } else if (!checkedAll && selectedRow.length === serviceListing?.data?.length) {
            // Only clear if all items were selected (meaning user clicked "uncheck all" header)
            setSelectedRow([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkedAll, serviceListing?.data]);

    const handleCheckboxChange = (e) => {
        setCheckedAll(false)
        let temp = []
        if (selectedRow && selectedRow?.length > 0 && selectedRow.includes(parseInt(e))) {
            temp = selectedRow.filter((x) => x !== parseInt(e)).map((y) => y)
            setSelectedRow(temp)
        } else {
            setSelectedRow([...selectedRow, parseInt(e)])
        }
    }

    const header = [
        {
            Header: "#",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <Checkbox
                            checked={checkedAll ? checkedAll : selectedRow?.length > 0 ? selectedRow.includes(cellProps.id) : false}
                            sx={{
                                color: '#D0D0D0',
                                '&.Mui-checked': {
                                    color: "var(--bs-theme-color)",
                                },
                                paddingBlock: 0
                            }}
                            value={cellProps.id}
                            onChange={(event) => handleCheckboxChange(event.target.value, cellProps)} />
                    </React.Fragment>
                )
            },
        },
        {
            Header: "Service Name",
            columnID: "service_type_name",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div className="d-flex align-items-center" style={{ paddingRight: "5px" }}>{cellProps?.service_type_name || '-'}</div>
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Service Type",
            columnID: "service_name",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div className="d-flex align-items-center" style={{ paddingRight: "5px" }}>{cellProps?.service_name || '-'}</div>
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Category Name",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div className="d-flex align-items-center" style={{ paddingRight: "5px" }}>{cellProps?.category_name || '-'}</div>
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Artwork",
            accessor: (cellProps) => {
                const imageUrl = cellProps?.image;
                return (
                    <React.Fragment>
                        {imageUrl ? (
                            <img
                                src={imageUrl}
                                alt=""
                                style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 6, border: '1px solid #EDEDED' }}
                            />
                        ) : (
                            <span style={{ color: '#999', fontSize: 12 }}>No image</span>
                        )}
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Status",
            columnID: "status",
            accessor: (cellProps) => {
                return (<React.Fragment><Label.StatusLabel label={cellProps?.status === 1 ? 'active' : 'inactive'} marginLeft={"0px"} /></React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        {editable && <Link to={`/settings-edit-product-service/${ID}/${cellProps?.id}`}>
                            <CustomIconButton
                                iconName={'ri-pencil-line'}
                                onClick={() => ''}
                            />
                        </Link>}
                        {deletable && <CustomIconButton
                            iconName={'ri-delete-bin-line'}
                            onClick={() => { setSelectedRow(cellProps); setDeleteModalOpen(true) }}
                            backgroundColor={'#44d62c'}
                            color={'white'}
                            borderStyle={"1px solid #44d62c"}
                        />}
                    </React.Fragment>
                )
            },
            minWidth: 120,
            position: 'sticky',
            disableFilters: true,
            filterable: false,
        }
    ]

    useEffect(() => {
        initData();
    }, [page, length, sort, filterStatus, sort_by])

    useEffect(() => {
        if (serviceList && !serviceTypeName) {
            let name = serviceList.filter((x) => parseInt(x.id) === parseInt(ID));
            name = name?.length > 0 ? name[0].name : '';
            setServiceTypeName(name);
        }
    }, [serviceList])

    useEffect(() => {
        if (exportServiceDocument?.code === 'success' && exportServiceDocument?.excel_base64) {
            Helpers.handleDownloadExcelFile(exportServiceDocument.excel_base64, 'service_listing');
            dispatch(resetServiceAttachmentState());
        }
        setIsLoading(false);
    }, [exportServiceDocument])

    useEffect(() => {
        if (bulkDelete?.code === "success") {
            setIsLoading(false);
            setDeleteModalOpen(false);
            setNotification({
                open: true,
                msg: "Delete Successfully",
                type: "success",
            })
            dispatch(resetServiceState())
            setCheckedAll(false);
            dispatch(getGeneral());
            initData()
        } else if (bulkDelete?.code === "invalid_service") {
            setIsLoading(false);
            setDeleteModalOpen(false);
            setNotification({
                open: true,
                msg: "Invalid service",
                type: "error",
            })
            dispatch(resetServiceState())
            initData()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bulkDelete]);

    const initData = () => {
        let payload = {
            service_id: ID,
            paginate: page,
            sort: sort_by,
            sort_order: sort,
            size: length,
            search: searchRef.current,
            filterStatus: filterStatus === 'all' ? '' : filterStatus
        }
        dispatch(getServiceListing(payload));
    }

    const handleExport = () => {
        let filter = {
            status: filterStatus,
            search: keyword,
            service_id: ID,
        };
        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all') {
                delete filter[key];
            }
        });
        setIsLoading(true);
        dispatch(exportService({
            sort: sort_by,
            sort_order: sort,
            filter: filter
        }));
    }

    const handleDelete = () => {
        if (selectedRow?.length > 0) {
            dispatch(bulkDeleteService({ ids: selectedRow }))

        } else {
            dispatch(deleteService(selectedRow.id));
        }
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage("1");
                initData();
            }
        }, Helpers.searchInterval);
    }

    const resetFilter = () => {
        setPage("1");
        setSearch('');
        setFilterStatus(filterStatus === '' ? 'all' : '');
    }

    const addServiceTypeModal = () => {
        return (
            <AppDialog
                title={'Add Servie Type'}
                open={addModalOpen}
                close={() => setAddModalOpen(false)}
                positiveTitle={'Save'}
                positivePress={() => ''}
                negativeTitle={'Cancel'}
                negativePress={() => setAddModalOpen(false)}
                width={'50%'}
            >
                <Grid container>
                    <Grid item sm={12}>
                        <CustomTextField
                            title={'Service Type'}
                            values={values?.service_type}
                            onChange={(e) => setFormValues((prevValues) => ({
                                ...prevValues,
                                service_type: e
                            }))}
                            placeholder="e.g. Warranty Upgrade"
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.service_type || ""}</FormHelperText>}
                    </Grid>
                    <Grid item sm={12} mt={2}>
                        <CustomTextField
                            title={'Sort order'}
                            values={values?.sort_order}
                            onChange={(e) => setFormValues((prevValues) => ({
                                ...prevValues,
                                sort_order: e
                            }))}
                            type={'number'}
                            placeholder="0"
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.sort_order || ""}</FormHelperText>}
                    </Grid>
                </Grid>
            </AppDialog>
        )
    }

    const editServiceTypeModal = () => {
        return (
            <AppDialog
                title={'Edit Service Type'}
                open={editModalOpen}
                close={() => setEditModalOpen(false)}
                positiveTitle={'Save Changes'}
                positivePress={() => ''}
                negativeTitle={'Cancel'}
                negativePress={() => setEditModalOpen(false)}
                width={'50%'}
            >
                <Grid container>
                    <Grid item sm={12}>
                        <CustomTextField
                            title={'Service Type'}
                            values={selectedRow?.service_type}
                            onChange={(e) => setSelectedRow((prevValues) => ({
                                ...prevValues,
                                service_type: e
                            }))}
                            placeholder="e.g. Warranty Upgrade"
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.service_type || ""}</FormHelperText>}
                    </Grid>
                    <Grid item sm={12} mt={2}>
                        <CustomTextField
                            title={'Sort order'}
                            values={selectedRow?.sort_order}
                            onChange={(e) => setSelectedRow((prevValues) => ({
                                ...prevValues,
                                sort_order: e
                            }))}
                            type={'number'}
                            placeholder="0"
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.sort_order || ""}</FormHelperText>}
                    </Grid>
                </Grid>
            </AppDialog>
        )
    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item xs={12} sm={8} md={8} lg={8} className="d-flex align-items-center" spacing={1}>
                    <Grid item lg={4} sm={4} xs={12}>
                        <SearchBar
                            value={keyword}
                            setValue={(e) => handleSearch(e)}
                        />
                    </Grid>
                    <Grid item lg={4} sm={4} xs={12}>
                        <CustomSelect2 values={filterStatus || "all"} onChange={(e) => { setPage("1"); setFilterStatus(e || '') }} data={Helpers.status} placeholder={'All statuses'} />
                    </Grid>
                    <Grid item lg={3} sm={3} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={4} lg={4} gap={1} sx={{ display: 'flex', justifyContent: { lg: 'end', sm: 'end' } }} alignItems={'center'}>
                    {exportable && <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />}
                    {deletable && selectedRow && selectedRow?.length > 0 && <CustomButton
                        title={<><i className="ri-delete-bin-line" style={{ marginRight: 5 }} />Delete</>}
                        press={() => setDeleteModalOpen(true)}
                        height={32}
                        borderRadius={15}
                        textColor={"white"}
                        backgroundColor={"#44d62c"}
                        borderStyle={"1px solid #44d62c"}
                    />}
                </Grid>
            </Grid>
        )
    }
    return (
        <React.Fragment>
            <div className="page-content">
                <LoadingDialog open={loading || !serviceListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumb
                        backRoute={'/settings-product-services'}
                        breadcrumbItems={[{ title: title, link: "/settings-product-services" },
                        { title: serviceTypeName, link: "#" },
                        ]}
                    >
                        {creatable && <CustomButton
                            title={<><i className="ri-add-line" style={{ marginRight: '5px' }} /> Add Service</>}
                            press={() => navigate(`/settings-add-product-service/${ID}`)}
                            height={40}
                            backgroundColor={'#101010'}
                            textColor={'white'}
                        />}
                    </Breadcrumb>
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={serviceListing?.data || []}
                        pageSize={length}
                        totalPage={serviceListing?.last_page || 1}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                        setCheckedAll={setCheckedAll}
                        checkedAll={checkedAll}
                    />

                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={serviceListing?.last_page || 1}
                    />
                    {addServiceTypeModal()}
                    {editServiceTypeModal()}
                    <DeleteModal
                        open={deleteModalOpen}
                        close={() => { setDeleteModalOpen(false); setSelectedRow([]); setCheckedAll(false); }}
                        submit={() => handleDelete()}
                        module={'service'}
                    />
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Service, General, Login }) {
    return {
        serviceListing: Service.serviceListing.data,
        bulkDelete: Service.bulkDeleteService,
        exportServiceDocument: Service.exportService,
        serviceList: General.services,
        userPermission: Login.permissionArry,
        deleteServiceItem: Service.deleteService,
    };
}

export default connect(mapStateToProps)(ViewService);
